import { connect } from 'react-redux'
import OpenForWorkComponent from '../../components/openforwork/openforwork.component'
import {
  loadOpenForWorkStart,
  updateOpenForWork,
  closeOpenForWorkSnackBar,
  getAreaOfExpertise,
  getAreaOfWork,
  notOpenForWork,
  loadProfileStart,
  getBillableHourUser
} from '../../actions/index'
import { groupWorkshiftByCompany } from './workshiftNormalUser.container'
import { getCompanyRatings } from '../../utils/openForWork.utils'

const mapStateToProps = (state) => {
  const areaExpertiseList = state.openForWork.areaExpertiseList
    ? state.openForWork.areaExpertiseList
    : []
  const areaOfWorkList = state.openForWork.areaOfWorkList
    ? state.openForWork.areaOfWorkList
    : []

  const billableHourUser = groupWorkshiftByCompany(
    state.workShiftUser.billableHourUserRow
  )
  const companyRatings = getCompanyRatings(billableHourUser)

  return {
    state,
    showSnackbar: state.openForWork.showSnackbar,
    showFailSnackbar: state.openForWork.showFailSnackbar,
    clearState: state.openForWork.clearState,
    applicationData: state.openForWork.applicationData,
    isEdit: state.openForWork.isEdit,
    areaExpertiseList: areaExpertiseList,
    areaOfWorkList: areaOfWorkList,
    userData: state.profile.userData,
    ratingsByCompany: companyRatings.result,
    ratingsSummary: companyRatings.summary,
    updatedFormSuccess: state.form?.openforwork?.updatedFormSuccess
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    loadOpenForWorkStart: () => dispatch(loadOpenForWorkStart()),
    updateOpenForWork: (formValues, files) =>
      dispatch(updateOpenForWork(formValues, files)),
    closeOpenForWorkSnackBar: () => dispatch(closeOpenForWorkSnackBar()),
    getAreaOfExpertise: () => dispatch(getAreaOfExpertise()),
    getAreaOfWork: () => dispatch(getAreaOfWork()),
    notOpenForWork: () => dispatch(notOpenForWork()),
    loadProfileStart: () => dispatch(loadProfileStart()),
    getBillableHourUser: () => dispatch(getBillableHourUser())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const OpenForWorkContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(OpenForWorkComponent)

export default OpenForWorkContainer
